// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"f72a72c13d0db2ee7838","691":"68ffd8c35516a54c4411","731":"e063394b0f09652d5c13","843":"fa624deba43fc7aa078a"}[chunkId] + ".js";
};